exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin8-bottom[data-v-aeca82a0] {\n  margin-bottom: 0.4rem;\n}\n.padding0-5 > div[data-v-aeca82a0] {\n  border-radius: 0.4rem;\n  margin-bottom: 0.4rem;\n  overflow: hidden;\n}\n.isiphoneX[data-v-aeca82a0] {\n  padding-bottom: 1rem;\n}", ""]);

// exports
